export const chainId = {
  BNB: 56,
  ETH : 1,
};

export const PUBLIC_NODES = {
  [chainId.BNB]: ['https://bsc-dataseed.binance.org/'],
  [chainId.ETH]: ['https://mainnet.infura.io/']

}